import parseQuantizedMesh from './lib/parse-quantized-mesh';
import loadTerrain from './lib/parse-terrain';
import { TerrainLoader as TerrainWorkerLoader } from './terrain-loader';
import { QuantizedMeshLoader as QuantizedMeshWorkerLoader } from './quantized-mesh-loader';

export { TerrainWorkerLoader };
export const TerrainLoader = {
  ...TerrainWorkerLoader,
  parse: loadTerrain
};
export const _typecheckTerrainLoader = TerrainLoader;

export { QuantizedMeshWorkerLoader };

export const QuantizedMeshLoader = {
  ...QuantizedMeshWorkerLoader,
  parseSync: parseQuantizedMesh,
  parse: async (arrayBuffer, options) => parseQuantizedMesh(arrayBuffer, options)
};
export const _typecheckQuantizedMeshLoader = QuantizedMeshLoader;
//# sourceMappingURL=index.js.map